import { useTranslation } from "@/composables/useTranslation";
import axios from 'axios'

const { translate } = useTranslation();

//Select 2
$(document).ready(function () {

  $('.select2').select2({})

  $('.select2-selection').addClass('form-v2m')

})

/*** FUNCIONES DEL PRIMER PASO DE LA ENTRADA DE DATOS *****/
export var nextText = ''
export var finishText = ''
export var confirmData = false
export var emailValid = false
export var nameValid = false
export var emailConfirmValid = false

//Funcion para validar el texto
export function validTexto (e, value) {
  //Validar solo textos y espacios
  let key = e.keyCode || e.which
  let tecla = String.fromCharCode(key).toLowerCase()
  let letras = ' áéíóúabcdefghijklmnñopqrstuvwxyz0123456789'
  let especiales = '8-37-39-46'

  let tecla_especial = false
  for (var i in especiales) {
    if (key == especiales[i]) {
      tecla_especial = true
      break
    }
  }

  if (letras.indexOf(tecla) == -1 && !tecla_especial) {
    return false
  }
}

export function validName () {
  const errorFirstName = document.getElementById('errorFirstname')
  const firstname = document.getElementById('user_register_form_firstname').value
  if (firstname === '') {
    errorFirstName.innerHTML = translate('label.firstname_required')
    nameValid = false
    return false
  }
  errorFirstName.innerHTML = ''

  const errorLastName = document.getElementById('errorSecondName')
  const lastname = document.getElementById('user_register_form_lastname').value
  if (lastname === '') {
    errorLastName.innerHTML = translate('label.lastname_required')
    nameValid = false
    return false
  }
  errorLastName.innerHTML = ''
  nameValid = true
  return true
}

//Funcion para validar el correo
export async function validEmail () {
  let btnNext = document.getElementById('btnFormNext')
  const error = document.getElementById('errorEmail')
  const email = document.getElementById('user_register_form_email_first').value
  const userID = document.getElementById('user_id').value
  const emailConfirm = document.getElementById('user_register_form_email_second')
  emailConfirm.dispatchEvent(new Event('change'))
  if (email === '') return false
  let re = /^([\da-zA-Z_\.-]+)@([\da-zA-Z\.-]+)\.([a-z\.]{2,6})$/

  if (!re.exec(email)) {
    error.innerHTML = translate('label.email_invalid')
    emailValid = false
  } else {
    //Validar correo

    const { data: emailExists } = await axios.post('/users/validateEmail', { 'email': email, 'userID': userID })

    if (emailExists) {
      error.innerHTML = translate('label.email_already_exists')
      emailValid = false
    } else {
      error.innerHTML = ''
      emailValid = true
    }

    return emailValid
  }
}

//Funcion para validar el correo de confirmacion
export function validEmailConfirm () {
  const error = document.getElementById('errorConfirmEmail')
  const email = document.getElementById('user_register_form_email_first').value
  const emailConfirm = document.getElementById('user_register_form_email_second').value
  if (emailConfirm == '') return false
  //Verificar que sean iguales
  if (email != emailConfirm) {
    emailConfirmValid = false
    error.innerHTML = translate('label.email_dont_match')
    return false
  }
  emailConfirmValid = true
  error.innerHTML = ''
  return true
}

//Funcion para validar la contraseña
export function validPassword () {
  const error = document.getElementById('errorPassword')
  const msgPasswordErrorName = document.getElementById('msgPasswordErrorName')
  const msgPasswordErrorLower = document.getElementById('msgPasswordErrorLower')
  const msgPasswordErrorUpper = document.getElementById('msgPasswordErrorUpper')
  const msgPasswordErrorSimbol = document.getElementById('msgPasswordErrorSimbol')
  const msgPasswordErrorMin = document.getElementById('msgPasswordErrorMin')
  const msgPasswordErrorNum = document.getElementById('msgPasswordErrorNum')

  const password = document.getElementById('user_register_form_password_first').value
  const companyName = document.getElementById('user_register_form_companyName').value
  let firstname = document.getElementById('user_register_form_firstname').value
  let lastname = document.getElementById('user_register_form_lastname').value
  let email = document.getElementById('user_register_form_email_first').value.split('@')[0]
  if (password === '') {
    error.style.display = 'none'
    return false
  }

  let validated = true

  let arrWordsCompanyName = companyName != '' ? companyName.split(' ') : []
  // delete number from arrWordsCompanyName
  for (let i = 0; i < arrWordsCompanyName.length; i++) {
    if (arrWordsCompanyName[i].match(/[0-9]/)) {
      arrWordsCompanyName.splice(i, 1)
      i--
    }
  }
  let containsCompanyName = false
  let password2 = password.toLowerCase()
  for (let i = 0; i < arrWordsCompanyName.length; i++) {
    if (password2.search(arrWordsCompanyName[i].toLowerCase()) != -1) {
      containsCompanyName = true
      i = arrWordsCompanyName.length + 1
    }
  }

  // Colocar el firstname en lower case y dividivirlo en palabras
  firstname = firstname.toLowerCase()
  firstname = firstname.split(' ')
  for (let i = 0; i < firstname.length; i++) {
    if (firstname[i].match(/[0-9]/)) {
      firstname.splice(i, 1)
      i--
    }
  }
  let containsFirstname = false
  for (let i = 0; i < firstname.length; i++) {
    if (password.search(firstname[i]) != -1) {
      containsFirstname = true
      i = firstname.length + 1
    }
  }
  // Colocar el lastname en lower case y dividivirlo en palabras
  lastname = lastname.toLowerCase()
  lastname = lastname.split(' ')
  for (let i = 0; i < lastname.length; i++) {
    if (lastname[i].match(/[0-9]/)) {
      lastname.splice(i, 1)
      i--
    }
  }
  let containsLastname = false
  for (let i = 0; i < lastname.length; i++) {
    if (password.search(lastname[i]) != -1) {
      containsLastname = true
      i = lastname.length + 1
    }
  }
  // Colocar el email en lower case y dividivirlo en palabras
  email = email.toLowerCase()
  email = email.split('@')
  for (let i = 0; i < email.length; i++) {
    if (email[i].match(/[0-9]/)) {
      email.splice(i, 1)
      i--
    }
  }
  let containsEmail = false
  for (let i = 0; i < email.length; i++) {
    if (password.search(email[i]) != -1) {
      containsEmail = true
      i = email.length + 1
    }
  }

  //Localizar similitudes
  if (firstname != '' && lastname != '' && email != '' && (containsCompanyName || containsFirstname || containsLastname || containsEmail)) {
    msgPasswordErrorName.style.display = 'block'
    validated = false
  } else {
    msgPasswordErrorName.style.display = 'none'
  }

  if (!/[a-z]/.test(password)) {
    msgPasswordErrorLower.style.display = 'block'
    validated = false
  } else {
    msgPasswordErrorLower.style.display = 'none'
  }

  if (!/[A-Z]/.test(password)) {
    msgPasswordErrorUpper.style.display = 'block'
    validated = false
  } else {
    msgPasswordErrorUpper.style.display = 'none'
  }

  if (!/[0-9]/.test(password)) {
    msgPasswordErrorNum.style.display = 'block'
    validated = false
  } else {
    msgPasswordErrorNum.style.display = 'none'
  }

  if (!/[`!@#$%^&*()_+\-=\[\]{};:\\|,.<>\/?~]/.test(password)) {
    msgPasswordErrorSimbol.style.display = 'block'
    validated = false
  } else {
    msgPasswordErrorSimbol.style.display = 'none'
  }

  if (password.length < 8) {
    msgPasswordErrorMin.style.display = 'block'
    validated = false
  } else {
    msgPasswordErrorMin.style.display = 'none'
  }
  //<--------------
  if (!validated) {
    error.style.display = 'block'
  } else {
    error.style.display = 'none'
  }
  return validated
}

//Funcion para validar la contraseña de confirmacion
export function validPasswordConfirm () {
  var error = document.getElementById('errorPasswordConfirm')
  var password = document.getElementById('user_register_form_password_first').value
  var passwordConfirm = document.getElementById('user_register_form_password_second').value
  if (passwordConfirm == '') return false
  //Verificar que sean iguales
  if (password != passwordConfirm) {
    error.innerHTML = translate('label.password_dont_match')
    return false
  }
  error.innerHTML = ''
  return true
}

//Funcion para validar el formulario y el boton de siguiente
export function validForm () {
  let btnNext = document.getElementById('btnFormNext')
  if (validName() && validPassword() && validPasswordConfirm()) {
    btnNext.removeAttribute('disabled')
    return true
  }
  btnNext.setAttribute('disabled', '')
  return false
}

/*** FUNCIONES DEL PRIMER PASO DE LA CONFIRMACIÓN DE DATOS *****/
export async function nextForm () {
  await validEmail()
  validEmailConfirm()
  if (!confirmData && emailValid && nameValid && emailConfirmValid) {
    confirmData = true
    document.getElementById('btnFormNext').innerHTML = translate('label.finish')
    document.getElementById('btnBackForm').innerHTML = translate('label.back')
    document.getElementById('user_register_form_companyName').setAttribute('readonly', '')
    document.getElementById('user_register_form_firstname').setAttribute('readonly', '')
    document.getElementById('user_register_form_lastname').setAttribute('readonly', '')
    document.getElementById('user_register_form_email_first').setAttribute('readonly', '')
    document.getElementById('user_register_form_email_second').setAttribute('readonly', '')
    document.getElementById('user_register_form_password_first').setAttribute('readonly', '')
    document.getElementById('user_register_form_password_second').setAttribute('readonly', '')
  } else if (confirmData && emailValid && nameValid && emailConfirmValid) {
    //Submit form
    let btnNext = document.getElementById('btnFormNext')
    btnNext.removeAttribute('disabled')
    document.getElementById('formUser').submit()
  }
}

//Funcion para controlar el comportamiento del boton de atras
export function backForm () {
  if (confirmData) {
    confirmData = false
    document.getElementById('btnFormNext').innerHTML = translate('label.next')
    document.getElementById('btnBackForm').innerHTML = translate('label.cancel')
    document.getElementById('btnFormNext').removeAttribute('readonly')
    document.getElementById('user_register_form_companyName').removeAttribute('readonly')
    document.getElementById('user_register_form_firstname').removeAttribute('readonly')
    document.getElementById('user_register_form_lastname').removeAttribute('readonly')
    document.getElementById('user_register_form_email_first').removeAttribute('readonly')
    document.getElementById('user_register_form_email_second').removeAttribute('readonly')
    document.getElementById('user_register_form_password_first').removeAttribute('readonly')
    document.getElementById('user_register_form_password_second').removeAttribute('readonly')
  } else {
    window.location = '/login'
  }
}
